import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useRegistrationForm } from "../core/RegistrationFormProvider";
import Button from "../../Button";
import logo from "../../../storage/logo.png";

const SelectCampTabContent = () => {
	const { isLoading, registerData, setRegisterData, camps } = useRegistrationForm();
	const { selectedCamp } = registerData || {};
	const [errors, setErrors] = React.useState([]);
	const [searchParams] = useSearchParams();

	const campParam = searchParams.get("camp");
	const isLocked = !!(campParam && registerData?.lockedCamp);

	let discountPriceDate = selectedCamp?.discount_price_ends_at || selectedCamp?.discount_price_ends;
	let shouldUseDiscount = !!selectedCamp?.discount_price;

	if (discountPriceDate) {
		const now = new Date();
		const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
		const discountEnds = new Date(discountPriceDate);
		const discountEndsDate = new Date(discountEnds.getFullYear(), discountEnds.getMonth(), discountEnds.getDate());
		shouldUseDiscount = discountEndsDate >= todayStart;

		discountPriceDate = [discountEndsDate.getDate(), discountEndsDate.getMonth() + 1, discountEndsDate.getFullYear()].join("/");
	}

	const handleContinue = async (e) => {
		e.preventDefault();

		try {
			await new Promise((resolve, reject) => {
				window.grecaptcha.ready(() => {
					window.grecaptcha
						.execute('6Lf0aG0sAAAAAE3wBuak_UDGCqeVK5JLUDR9F_Kt', { action: 'registration' })
						.then(resolve)
						.catch(reject);
				});
			});
			setRegisterData({ ...registerData, step: 3 });
		} catch (error) {
			console.error('reCAPTCHA error:', error);
			setErrors(['אימות האבטחה נכשל. אנא נסה שוב.']);
		}
	};

	// Auto-select camp from URL param
	useEffect(() => {
		if (!campParam || !camps || camps.length === 0) return;

		const campId = parseInt(campParam);
		const camp = camps.find((c) => c.id === campId);

		if (camp && (!selectedCamp || selectedCamp.id !== campId)) {
			setRegisterData({
				...registerData,
				selectedCamp: camp,
				lockedCamp: true,
			});
		}
	}, [camps, campParam]);

	// Default camp selection (no URL param)
	useEffect(() => {
		if (campParam) return;
		if (!selectedCamp && camps && camps.length > 0) {
			const visibleCamps = camps.filter((camp) => camp.hidden_at === null);
			if (visibleCamps.length > 0) {
				setRegisterData({
					...registerData,
					selectedCamp: visibleCamps[0],
				});
			}
		}
	}, [camps, selectedCamp]);

	return (
		<div
			className="min-h-screen w-full bg-cover bg-center"
			style={{ backgroundImage: "url(/keytana.jpg)", backgroundColor: "#1a1a2e" }}
		>
			<div className="min-h-screen w-full bg-white/30 backdrop-blur-sm">
				<div className="min-h-screen w-full flex items-center justify-center px-4 py-10">
					<div className="relative w-full max-w-xl rounded-3xl bg-white/95 text-black shadow-2xl px-8 py-10 text-center">
						<div className="absolute -top-12 left-1/2 -translate-x-1/2 w-24 h-24 rounded-full bg-white border-4 border-yellow-400 shadow-lg flex items-center justify-center">
							<img src={logo} alt="logo" className="w-16 h-16 object-contain" />
						</div>
						<strong className="text-3xl font-semibold mb-2 block">בחר קייטנה</strong>
						<p className="text-sm text-gray-600 mb-6">בחרו את הקייטנה המתאימה לכם והמשיכו להרשמה</p>
						<div className="mb-6">
							{isLocked ? (
								<div className="w-full px-5 py-4 rounded-2xl bg-yellow-50 border border-yellow-300 text-black text-sm text-right font-semibold">
									{selectedCamp?.name || "טוען..."}
								</div>
							) : !isLoading && camps && camps.length ? (
								<select
									className="w-full px-5 py-4 rounded-2xl bg-gray-100 text-black text-sm border border-gray-200 focus:outline-none"
									value={selectedCamp?.id || ""}
									onChange={(e) => {
										setRegisterData({
											...registerData,
											selectedCamp: camps.find((camp) => camp.id === parseInt(e.target.value)),
										});
									}}>
									{camps
										.filter((camp) => camp.hidden_at === null)
										.map((camp) => (
											<option key={camp.id} value={camp.id}>
												{camp.name}
											</option>
										))}
								</select>
							) : (
								<div>בטעינה...</div>
							)}
						</div>
						{selectedCamp && (
							<div className="mx-auto mb-6 text-base text-right max-w-xs">
								<div className="flex items-center justify-between">
									<span className="font-semibold text-lg">מחיר:</span>
									<span className="text-lg">
										{selectedCamp.discount_price && shouldUseDiscount ? (
											<span>
												<del className="text-sm text-gray-400">₪{selectedCamp.price}</del>
												&nbsp;&nbsp;
												<span className="font-semibold">₪{selectedCamp.discount_price}</span>
											</span>
										) : (
											<span className="font-semibold">₪{selectedCamp.price}</span>
										)}
									</span>
								</div>
								{selectedCamp.discount_price && selectedCamp.discount_price_ends_at ? (
									<span className="block mt-1 text-sm text-gray-500">המחיר בתוקף עד {discountPriceDate}</span>
								) : null}
							</div>
						)}
						<div>
							{errors.length > 0 && (
								<div className="text-red-600 mb-4">
									{errors.map((error, index) => (
										<div key={index}>{error}</div>
									))}
								</div>
							)}
							<div className="flex justify-between items-center gap-4">
								<Button
									onClick={() => setRegisterData({ ...registerData, step: 1 })}
									className="shadow-lg">
									חזור
								</Button>
								<Button
									onClick={handleContinue}
									disabled={selectedCamp == null}
									className="flex-1 shadow-lg">
									המשך
								</Button>
							</div>
						</div>
						<p className="text-xs text-gray-500 mt-6">אקשן על גלגלים — הקייטנה הכי כיפית</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default function SelectCampTab() {
	return <SelectCampTabContent />;
}
